module.exports = __webpack_public_path__ + "static/img/newLogo-white.75268a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newLogo-white.png
// module id = W0Kw
// module chunks = 2